export default  {
  bindings: {
    category: '=',
    treatments: '<',
    days: '<',
    categories: '<',
    title: '@'
  },
  controller: 'categorySaveController',
  template: require('../views/category.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/category.save.component.js